import { Button } from '@simplywallst/ui-core';

import { FairValueTooltip } from './components/FairValueTooltip';
import { TitleWithTooltip } from '../TitleWithTooltip';
import { usePathname } from '@/hooks/location/usePathname';
import { narrativeFvModalReturnPath } from '../../utils';
import { useCreateNarrative } from '@/pages/Narrative/hooks/useCreateNarrative';

type Props = {
  companyId: string;
  userHoldsPosition?: boolean;
};

export const ValuationOptionBuildMyNarrative = ({
  companyId,
  userHoldsPosition,
}: Props) => {
  const pathname = usePathname();

  const { handleCreateNarrative } = useCreateNarrative({
    companyId,
    returnPath: narrativeFvModalReturnPath(pathname, companyId),
    userHoldsPosition,
  });

  return (
    <div
      className="grid grid-rows-[max-content_max-content] items-center justify-between
      gap-4 bg-surface-2
      p-6 min-[375px]:rounded-x1
      sm:grid-cols-[1fr_max-content] sm:grid-rows-[max-content]"
    >
      <div>
        <TitleWithTooltip tooltip={<FairValueTooltip />}>
          My Fair Value
        </TitleWithTooltip>
        <div className="text-xs text-soft">
          Create your own narrative on this stock, and estimate its Fair Value
          using our Valuator tool
        </div>
      </div>

      <Button styleType="loudLarge" onClick={handleCreateNarrative}>
        Build My Narrative
      </Button>
    </div>
  );
};
